window.jQuery = window.jquery = window.$ = require('jquery');
require('bootstrap');
window.moment = require('moment');
require('simplebar');
require('daterangepicker');
require('metismenu');
require('jquery-toast-plugin');
require('select2');
require('twitter-bootstrap-wizard');
require('bootstrap-timepicker');
require('bootstrap-touchspin');
require('bootstrap-maxlength');
require('bootstrap-datepicker');
require('highlightjs');
require('../vendor/hyper/js/layout');
require('../vendor/hyper/js/hyper');
require('../vendor/hyper/js/ui/component.fileupload');

$('.select2-tags').each(function () {
    $(this).select2({
        tags: true,
    });
});

$('.form-secured').each(function () {
    const listener = function (event) {
        event.preventDefault();
        return (event.returnValue = 'Weet u zeker dat u weg wilt navigeren?');
    };

    addEventListener('beforeunload', listener);

    $(this).on('submit', function () {
        removeEventListener('beforeunload', listener);
    });
});

const ApexCharts = require('apexcharts');
$('.pie-chart').each(function () {
    let series = String($(this).data('series'))
        .split('|')
        .map((value) => parseFloat(value));
    const options = {
        chart: {
            height: 213,
            type: 'donut',
        },
        legend: {
            show: false,
        },
        stroke: {
            colors: ['transparent'],
        },
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return Math.round((val / 100) * series.reduce((p, c) => p + c, 0));
            },
        },
        series: series,
        labels: String($(this).data('labels')).split('|'),
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200,
                    },
                    legend: {
                        position: 'bottom',
                    },
                },
            },
        ],
    };

    const chart = new ApexCharts($(this).get(0), options);

    chart.render();
});
